import { ApiClientError, DeleteResourceACLV5 } from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

type DeleteResourceACLV5Input = {
  resourceId: string;
  params: DeleteResourceACLV5;
};

export default function useDeleteResourceACLV5() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    void,
    ApiClientError,
    DeleteResourceACLV5Input // Separate input fields
  >(
    async ({ resourceId, params }) => {
      // Combine resourceId and params
      const response = await raydiant.deleteResourceACLV5(resourceId, params);
      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );

  return mutation;
}
